import { css } from '@emotion/css';
import { baseTheme } from '@toeverything/theme';

export const formulaBadgeStyle = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '100%',
  height: '100%',
  padding: '0 8px',
  border: 'none',
  fontFamily: baseTheme.fontSansFamily,
  fontSize: 'var(--data-view-cell-text-size)',
  lineHeight: 'var(--data-view-cell-text-line-height)',
  color: 'var(--affine-text-primary-color)',
  fontWeight: '400',
  backgroundColor: 'transparent',
});

export const formulaPlaceholderStyle = css({
  color: 'var(--affine-text-secondary-color)',
  fontStyle: 'italic',
});

export const formulaErrorStyle = css({
  color: 'var(--affine-error-color)',
});

export const formulaRowOverrideWrapperStyle = css({
  position: 'relative',
  width: '100%',
  height: '100%',
  // The row-override badge is only revealed on hover or when the cell is
  // active, so it doesn't clutter the table or overlap the value.
  '&:hover > [data-row-formula-badge], &[data-active="true"] > [data-row-formula-badge]':
    {
      opacity: 1,
    },
});

export const formulaRowOverrideBadgeStyle = css({
  position: 'absolute',
  top: '2px',
  right: '4px',
  fontSize: '10px',
  fontWeight: '600',
  fontStyle: 'italic',
  lineHeight: 1,
  color: 'var(--affine-icon-secondary-color)',
  cursor: 'pointer',
  userSelect: 'none',
  opacity: 0,
  transition: 'opacity 120ms ease-out',
});
